/**
 * Class that returns the speed of the network by measurements done on the number of bytes uploaded
 */
export class SpeedoMeter {

    /**
     * Init the time the network operation (upload/download) started 
     */
    public readonly startTime: number = performance.now();

    /**
     * Any offset that we want to exclude from the total time
     * This is useful if we there is a wait time in the caller code and we want to exclude that wait time from the calculation
     */
    private offsetInMs: number = 0;
    
    /**
     * Adds specific number of extra milliseconds to the start time
     * @param ms The milliseconds to add
     */
    public addToOffset(ms: number) {
        this.offsetInMs += ms;
    }
    
    /**
     * Gets the speed of the network (in gbps)
     * @param bytes The number of bytes downloaded/uploaded
     */
    public getSpeedInGbps(bytes: number): string {
        const speedInBitsPerSecond = this.getSpeedInBitsPerSecond(bytes);
        return `${(speedInBitsPerSecond / 1000 / 1000 / 1000).toFixed(2)} Gbps`;
    }
    
    /**
     * Gets the speed of the network (in mbps)
     * @param bytes The number of bytes downloaded/uploaded
     */
    public getSpeedInMbps(bytes: number): string {
        const speedInBitsPerSecond = this.getSpeedInBitsPerSecond(bytes);
        return `${(speedInBitsPerSecond / 1000 / 1000).toFixed(2)} Mbps`;
    }
    
    /**
     * Gets the speed of the network (in bytes)
     * @param bytes The number of bytes downloaded/uploaded
     */
    public getSpeedInKbps(bytes: number): string {
        const speedInBitsPerSecond = this.getSpeedInBitsPerSecond(bytes);
        return `${(speedInBitsPerSecond / 1000).toFixed(2)} Kbps`;
    }
    
    /**
     * Gets the speed of the network (in bits)
     * @param bytes The number of bytes downloaded/uploaded
     */
    private getSpeedInBitsPerSecond(bytes: number): number {
        const endTime = performance.now() - this.offsetInMs;
        
        const totalSeconds = (endTime - this.startTime) / 1000;
        return (bytes * 8) / totalSeconds;
    }
}